import { FC } from 'react'

import styled from 'styled-components'
import { useDisclosure } from '@mantine/hooks'
import { Control, Controller } from 'react-hook-form'

import { IconButton } from 'src/Components/Button/IconButton.tsx'
import { Input } from 'src/Components/Input/index.tsx'
import { Select } from 'src/Components/Select'
import { colors, device } from 'src/Helpers/constants.ts'
import IconCirclePlus from 'src/Assets/addButton.svg?react'
import { SearchTransportFormData } from 'src/Pages/Transport/index.tsx'
import { ModelType } from 'src/Redux/api/modelTypesApi.ts'

const ControlsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 17px;
`

const FiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  position: relative;

  @media ${device.tabletMax} {
    width: 100%;
  }
`

const StyledSelect = styled(Select)`
  width: 100%;
`

const DropdownContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;
  margin-top: 5px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`

const StyledInput = styled(Input)`
  width: 500px;
  input {
    border: 1px solid ${colors.secondGray};
    color: ${colors.thirdBlue};
    --input-placeholder-color: ${colors.thirdBlue};
  }

  @media ${device.tabletMax} {
    width: 100%;
  }
`

const StyledButton = styled(IconButton)`
  svg {
    path {
      fill: ${colors.fourthBlue};
    }
  }
`

const OWNERSHIP_OPTIONS = [
  { value: 'true', label: 'В собственности' },
  { value: 'false', label: 'Не в собственности' },
]

interface SearchBlockProps {
  onOpenAddModal: () => void
  control: Control<SearchTransportFormData>
  modelTypes?: ModelType[]
}
export const SearchBlock: FC<SearchBlockProps> = ({
  onOpenAddModal,
  control,
  modelTypes,
}) => {
  const [opened, { toggle }] = useDisclosure(false)

  const typeSelectData = modelTypes?.map((modelType) => {
    return {
      value: String(modelType.id),
      label: modelType.label,
    }
  })

  return (
    <ControlsContainer>
      <StyledButton
        onClick={onOpenAddModal}
        tooltiptext={'Добавить технику'}
        data-testid={'add-equipment'}
      >
        <IconCirclePlus />
      </StyledButton>

      <FiltersContainer>
        <Controller
          name='searchTerm'
          control={control}
          render={({ field }) => (
            <StyledInput
              placeholder={'Поиск + фильтр'}
              {...field}
              onClick={toggle}
            />
          )}
        />

        {opened && (
          <DropdownContainer>
            <Controller
              name='selectedType'
              control={control}
              render={({ field }) => (
                <StyledSelect
                  placeholder='Тип техники'
                  data={typeSelectData}
                  {...field}
                  onChange={(value) => {
                    field.onChange(value)
                  }}
                  clearable
                />
              )}
            />
            <Controller
              name='ownership'
              control={control}
              render={({ field }) => (
                <StyledSelect
                  placeholder='Собственность'
                  data={OWNERSHIP_OPTIONS}
                  {...field}
                  clearable
                  data-testid='ownership-filter'
                />
              )}
            />
          </DropdownContainer>
        )}
      </FiltersContainer>
    </ControlsContainer>
  )
}
